module.exports = "/_next/static/images/worksCelebrate-ce2d8d0fbc2dd0efc6d4c4fe8effbf71.svg";